var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", { staticClass: "unstriped hover boss-table" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("tbody", [
      _vm.isEmptyCompany
        ? _c("tr", [
            _c(
              "td",
              { attrs: { colspan: "3", "data-test": "company-no-data" } },
              [_vm._v("\n        ※掲載前確認中の企業情報はありません\n      ")]
            ),
          ])
        : _c("tr", [
            _c(
              "td",
              {
                staticClass: "boss-table-data",
                attrs: { "data-test": "company-id" },
              },
              [_vm._v("\n        " + _vm._s(_vm.company.id) + "\n      ")]
            ),
            _vm._v(" "),
            _c(
              "td",
              {
                staticClass: "boss-table-data",
                attrs: { "data-test": "company-name" },
              },
              [_vm._v("\n        " + _vm._s(_vm.company.name) + "\n      ")]
            ),
            _vm._v(" "),
            _c("td", { staticClass: "boss-table-data" }, [
              _c(
                "button",
                {
                  staticClass: "boss-button pega-width-5-5rem",
                  attrs: { "data-test": "company-preview-button" },
                  on: { click: _vm.windowOpenPreview },
                },
                [_vm._v("\n          企業情報\n        ")]
              ),
            ]),
          ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "boss-table-head-center" }, [
          _vm._v("\n        企業ID\n      "),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "boss-table-head-center" }, [
          _vm._v("\n        企業名\n      "),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "boss-table-head-center" }, [
          _vm._v("\n        プレビュー\n      "),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }